var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    [
      _vm.title
        ? _c("b-row", [_c("b-col", [_c("h3", [_vm._v(_vm._s(_vm.title))])])], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c(
            "b-row",
            [
              _c("b-col", {
                staticClass: "description",
                domProps: { innerHTML: _vm._s(_vm.description) },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "form-row" },
        [
          _c(
            "b-col",
            [
              _vm.formLoading
                ? [
                    _c("loading-spinner", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "message",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n            Loading form\n          "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2315081702
                      ),
                    }),
                  ]
                : [
                    _c(
                      "no-ssr",
                      [
                        _c("form-renderer", {
                          attrs: {
                            form: _vm.formItem,
                            data: _vm.formfieldtokens,
                            "recaptcha-key": _vm.recaptchaKey,
                          },
                          on: {
                            success: _vm.formSubmissionSucceed,
                            failure: _vm.formSubmissionFailed,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }